<template>
  <v-col cols="12" class="pa-0 pl-5 pr-5">
    <v-sheet rounded="lg">
      <v-container fluid>
        <h1>pos qr</h1>
        <paragrafo>
          Na tela inicial estão as opções de busca de produtos por categoria e
          por regional ou somente por regional.
        </paragrafo>
        // imagem
        <paragrafo
          >Abaixo há o botão para login na sua conta, na qual o cliente será
          redirecionado para a tela de login, onde há quatro opções:
        </paragrafo>
        <li>Login para quem já é cliente;</li>
        <li>Login através do Facebook;</li>
        <li>Login através da conta Google;</li>
        <li>Cadastro de nova conta para clientes novos.</li>
        // imagem
        <paragrafo
          >Ainda nesta tela estão disponíveis as opções de troca de senha
          (Esqueci minha senha) e a Política de Privacidade.</paragrafo
        >
        <paragrafo
          >Nesta tela serão exibidos todos os produtos da regional. É possível
          buscar por uma nova categoria e pesquisar pelo nome do
          produto.</paragrafo
        >
        // imagem
        <paragrafo
          >Ao clicar em <negrito>Comprar Agora</negrito>, o cliente será
          redirecionado para a tela abaixo:
        </paragrafo>
        // imagem
        <paragrafo>
          <li>
            Botão de Comprar Mais possibilita adicionar produtos diferentes no
            carrinho
          </li>
          <li>
            Botões de adição e subtração permitem selecionar a quantidade de
            itens desejada.
          </li>
        </paragrafo>
        <paragrafo
          >Após clicar em <negrito>Finalizar Compra</negrito>, ela estará
          disponível no carrinho.
        </paragrafo>
        <paragrafo
          >Cada produto pode ser excluído individualmente (ícone vermelho da
          lixeira) ou em conjunto, clicando no botão
          <negrito>Limpar Carrinho</negrito>.
        </paragrafo>
        // imagem
        <h1>Tela de pagamento</h1>
        <paragrafo>Possui opções de pagamento em pix ou crédito. </paragrafo>
        <paragrafo
          >No botão de <negrito>Ver Mais</negrito> é possível voltar e adicionar
          mais itens.
        </paragrafo>
        <paragrafo
          >Caso queira concluir, clique em <negrito>Pagar</negrito>.
        </paragrafo>
        // imagem
        <paragrafo
          >Estando logado, nos cantos superiores, esquerdo e direito, estão
          ícones de acesso rápido.
        </paragrafo>
        <paragrafo
          >Na esquerda estão: <negrito>Home</negrito>,
          <negrito>Política de Privacidade</negrito> e
          <negrito>Política de Cookies</negrito>.
        </paragrafo>
        // imagem
        <paragrafo
          >Na direita estão: <negrito>Carrinho</negrito>,
          <negrito>Meus Dados</negrito>, <negrito>Meus Pedidos</negrito> e
          <negrito>Sair</negrito>
        </paragrafo>
        // imagem
        <paragrafo
          >Utilize a opção <negrito>Meus Dados</negrito> para atualizar o
          cadastro
        </paragrafo>
        // imagem
        <paragrafo
          >Utilize Meus Pedidos para visualizar os ingressos, confirmação de
          pagamentos e cancelados. É possível filtrar por período mensal.
        </paragrafo>
        // imagem
      </v-container>
    </v-sheet>
  </v-col>
</template>
<script>
export default {
  name: "posQR",
  components: {
    paragrafo: () => import("@/docs/components/infos/paragrafo.vue"),
    // imagem: () => import("@/docs/components/infos/imagem.vue"),
    negrito: () => import("@/docs/components/infos/negrito.vue"),
  },
  data() {
    return {};
  },
};
</script>
